var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f4351;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,8A12,12,0,1,0,32,20,12,12,0,0,0,20,8Zm5.6,13.161-8.516,4.887a1.163,1.163,0,0,1-1.727-1.016V14.968a1.164,1.164,0,0,1,1.727-1.016L25.6,19.129A1.165,1.165,0,0,1,25.6,21.161Z",
    transform: "translate(-8 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleSolid);
export default __webpack_public_path__ + "static/media/play-circle-solid.efaa0203a62436b2ca4f865e181417d0.svg";
export { ForwardRef as ReactComponent };